'use client'

import { useEffect, useState } from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { isDiscountBuyAvailable } from '@/entities/catalog-discount'

import { BASE_URL } from '@/shared/lib/const/env'
import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { scrollObserver } from '@/shared/lib/utils/scroll/scrollObserver'
import { OrderType } from '@/shared/types/product-types'
import { Image } from '@/shared/ui/Image'
import { ProductPrice } from '@/shared/ui/product/ProductPrice'

import cl from '../../ui/product-main/product-panel/components/product-page-fixed-panel/product-page-fixed-panel.module.scss'

import { DiscountBuyButton } from './discount-buy-button'

export const DiscountProductFixedPanel = (): JSX.Element | null => {
	const { product } = useProduct()
	const { isMobile } = useMediaQueries()
	const [isHidden, setIsHidden] = useState(true)
	const [isReadyForDeviceDetect, setIsReadyForDeviceDetect] = useState(false)

	useEffect(() => {
		if (isMobile) {
			setIsHidden(false)
			setIsReadyForDeviceDetect(true)
			return
		}

		setIsReadyForDeviceDetect(true)

		return scrollObserver({
			nodeId: `productTitle`,
			observerHandler: observer => setIsHidden(observer[0].isIntersecting),
			rootMargin: 0
		})
	}, [isMobile])

	const imgSrc = product.IMAGES?.[0] || product.IMAGE
	const isPriceVisible = product.VISIBLE_PRICE
	const hiddenClass = isReadyForDeviceDetect && !isMobile && isHidden ? cl['productBottomPanel--hidden'] : ''
	const panelClassName = `${cl.productBottomPanel} ${hiddenClass}`.trim()

	if (!isDiscountBuyAvailable(product) || product.ORDER_TYPE === OrderType.Archive) return null

	return (
		<section className={panelClassName}>
			<div className={cl.productBottomPanel__deskWrap}>
				<div className={cl.productBottomPanel__content}>
					{!!imgSrc && (
						<div className={cl.productBottomPanel__imageWrap}>
							<Image alt={product.TITLE} src={BASE_URL + imgSrc} width={50} height={50} />
						</div>
					)}
					<div className={cl.productBottomPanel__info}>
						<p
							className={cl.productBottomPanel__title}
							dangerouslySetInnerHTML={createMarkup(`Купить ${product.TITLE}`)}
						/>
						{isPriceVisible && (
							<div className={cl.productBottomPanel__price}>
								<ProductPrice is_archive={false} price={product.PRICE} oldPrice={product.OLD_PRICE} flat revert />
							</div>
						)}
					</div>
					<div className={cl.productBottomPanel__desktopButton}>
						<DiscountBuyButton product={product} size="M" fullWidth inFixedPanel />
					</div>
				</div>
			</div>

			<div className={cl.productBottomPanel__mobWrap}>
				{isPriceVisible && (
					<div className={cl.productBottomPanel__price}>
						<ProductPrice is_archive={false} price={product.PRICE} oldPrice={product.OLD_PRICE} flat revert />
					</div>
				)}
				<DiscountBuyButton product={product} size="L" fullWidth inFixedPanel />
			</div>
		</section>
	)
}
